/* config */
const configFolderPath = "config/";
export const getInitConfigUrl = () => configFolderPath + "config.json";
export const getAppConfigUrl = () => configFolderPath + "appConfig.json";
export const getMapLayersConfigUrl = () => configFolderPath + "mapLayersConfig.json";
export const getModuleConfigsUrl = () => configFolderPath + "modulesConfig.json";
export const getCustomCssUrl = () => configFolderPath + "custom.css";

/* hub */
export const getHubStartupInfoUrl = () => "hub/startupInfo";
export const getHubMinimalInfoUrl = () => "hub/minimalInfo";
export const getSetMachineToMachineCredentialsUrl = hubId => `MachineToMachineInteraction/Credentials/?hubId=${hubId}`;
export const getAppLicenseUrl = () => "license/info";

/* node */
export const getNodeUrl = nodeId => `nodes/${nodeId}`;
export const getNodeCatalogUrl = nodeId => `nodes/${nodeId}/catalog`;

/* cache */
export const getClearMemoryCacheUrl = () => "MemoryCache/Clear";
export const getDataflowsCacheListUrl = nodeId => `DataflowCache/DataflowData/Nodes/${nodeId}`;
export const getDataflowsCacheUpdateUrl = (nodeId, cacheId) => `DataflowCache/DataflowData/${cacheId}/Nodes/${nodeId}`;
export const getDataflowsCreateCacheUrl = nodeId => `DataflowCache/DataflowData/Nodes/${nodeId}`;
export const getDataflowsClearCacheUrl = (nodeId, cacheId) => `DataflowCache/Clear/${cacheId}/Nodes/${nodeId}`;
export const getDataflowsClearAllCacheUrl = nodeId => `DataflowCache/ClearAll/Nodes/${nodeId}`;
export const getClearNodeCatalogMemoryCacheUrl = nodeId => `MemoryCache/Clear/CatalogTree/Nodes/${nodeId}`;

export const getDatasetCacheInfoUrl = (nodeId, datasetId) => `DataflowCache/DataflowData/${datasetId}/Nodes/${nodeId}`;
export const clearDatasetCacheUrl = (nodeId, datasetId) => `Caches/Nodes/${nodeId}/ClearDataflow/${datasetId}`;
export const getDatasetCacheUpdateUrl = (nodeId, datasetId) => `DataflowCache/${datasetId}/Nodes/${nodeId}`;
export const getArtefactCacheClearAllUrl = (nodeId, preserveDataflows) =>
  `ArtefactCache/Nodes/${nodeId}/ClearAll?preserveDataflows=${preserveDataflows}`;
export const getArtefactCacheClearUrl = (nodeId, structureType, structureId, references) =>
  `ArtefactCache/Nodes/${nodeId}/Clear/${structureType}/${structureId}${references ? `?references=${references}` : ""}`;

/* templates */
export const getNodeTemplatesUrl = nodeId => `nodes/${nodeId}/templates`;
export const getCreateTemplateUrl = nodeId => `nodes/${nodeId}/templates`;
export const getDeleteTemplateUrl = (nodeId, id) => `nodes/${nodeId}/templates/${id}`;

/* views */
export const getViewsUrl = () => `views`;
export const getCreateViewUrl = nodeId => `nodes/${nodeId}/views`;
export const getDeleteViewUrl = (nodeId, id) => `nodes/${nodeId}/views/${id}`;
export const getItemContainerNodeView = (nodeId, id) => `ItemContainers/nodes/${nodeId}/views/${id}`;

/* dataset */
export const getDatasetUrl = (nodeId, packageId, datasetId, lastNObservations) =>
  `nodes/${nodeId}/packages/${packageId}/datasets/${datasetId.replace(/\+/g, ",")}/data` +
  (lastNObservations ? `?lastNObservations=${lastNObservations}` : "");
export const getDatasetStructureUrl = (nodeId, packageId, datasetId, viewId) =>
  `nodes/${nodeId}/packages/${packageId}/datasets/${datasetId}/structure${viewId ? `/${viewId}` : ""}`;
export const getDatasetStructureCodelistUrl = (nodeId, packageId, datasetId, dimensionId, isFull) =>
  `nodes/${nodeId}/packages/${packageId}/datasets/${datasetId}/column/${dimensionId}/${isFull ? "full" : "partial"}/values`;
export const getDatasetStructureDynamicCodelistUrl = (nodeId, packageId, datasetId, dimensionId) =>
  `nodes/${nodeId}/packages/${packageId}/datasets/${datasetId}/PartialCodelists/${dimensionId}`;
export const getDatasetStructureCodelistsUrl = (nodeId, packageId, datasetId, isFull = false) =>
  `nodes/${nodeId}/packages/${packageId}/datasets/${datasetId}/columns/${isFull ? "full" : "partial"}/values`;
export const getDatasetDownloadUrl = (nodeId, packageId, datasetId, format, zipped, lastNObservations) =>
  `nodes/${nodeId}/packages/${packageId}/datasets/${datasetId}/${zipped === true ? "downloadZip" : "download"}/${format}${
    lastNObservations ? `?lastNObservations=${lastNObservations}` : ""
  }`;
export const getDatasetCustomDownloadUrl = (nodeId, format, zipped, lastNObservations) =>
  `nodes/${nodeId}/export/${format}/${zipped === true ? "true" : "false"}${
    lastNObservations ? `?lastNObservations=${lastNObservations}` : ""
  }`;
export const getDatasetSdmxQueryUrl = (nodeId, packageId, datasetId, lastNObservations) =>
  `nodes/${nodeId}/packages/${packageId}/datasets/${datasetId}/url${
    lastNObservations ? `?lastNObservations=${lastNObservations}` : ""
  }`;

/* indicators */
export const getDatasetWithMarginalUrl = () => `marginal`;
export const getDatasetWithIndicatorsUrl = (isPreview = false) => `data?preview=${isPreview}`;
export const getDatasetWithMarginalCustomDownloadUrl = (format, zipped) =>
  `export/${format}/${zipped === true ? "true" : "false"}`;

/* detail levels */
export const getDatasetDetailLevels = (nodeId, datasetId) => `nodes/${nodeId}/datasets/${datasetId}/detailLevels`;
export const getDatasetTerritories = (nodeId, datasetId, territoryDim, detailLevel, optimizedData = false) =>
  `nodes/${nodeId}/datasets/${datasetId}/detailLevelItems/${territoryDim}/${detailLevel}` +
  (optimizedData ? `?optimizedData=true` : "");
export const getDeleteNodeDatasetDetailLevels = nodeId => `nodes/${nodeId}/detailsLevels`;

/* metadata */
export const getDatasetExportJsonMetadataUrl = (nodeId, packageId) =>
  `nodes/${nodeId}/packages/${packageId}/ExportJsonMetadata`;
export const getDatasetExportHtmlMetadataUrl = (nodeId, packageId) =>
  `nodes/${nodeId}/packages/${packageId}/ExportMetadata`;

/* config */
export const getHubConfigGetUrl = () => "hub/config";
export const getHubConfigPutUrl = () => "hub";
export const getNodesConfigUrl = () => "nodes/config";
export const getNodesOrderPutUrl = () => "nodes/order";
export const getNodeConfigGetUrl = nodeId => `nodes/${nodeId}/config`;
export const getNodesConfigPostUrl = () => "nodes";
export const getNodesConfigPutUrl = nodeId => `nodes/${nodeId}`;
export const getNodeDeleteUrl = (nodeId, force) => `nodes/${nodeId}${force ? "/true" : ""}`;
export const getNodePingUrl = () => "Endpoint/Ping";

export const getMergedNodeConfigCreateUrl = () => "mergedNode";
export const getMergedNodeConfigEditUrl = nodeId => `mergedNode/${nodeId}`;
export const getMergedNodeConfigGetUrl = nodeId => `mergedNode/${nodeId}/config`;

export const getNodeExportUrl = nodeCode => `Export/Nodes/${nodeCode}`;
export const getNodeImportUrl = () => "Import/Nodes/Info";

/* log */
export const getQueryLog = limit => `tracing/limit/${limit}`;

/* files */
export const getFileUploadUrl = () => "File/Upload";

/* authentication */
export const getTokenUrl = () => "auth/token";
export const getRemoveTokenUrl = userId => `auth/removeToken/${userId}`;
export const getExternalLoginUrl = providerId => `auth/provider/${providerId}`;
export const getExternalLogoutUrl = userId => `logout/provider/${userId}`;

/* users management */
export const getUsersConfigGetUrl = () => "users";
export const getUserConfigGetUrl = userId => `users/${userId}`;
export const getUserConfigPostUrl = () => "users/register";
export const getUserConfigPutUrl = userId => `users/${userId}`;
export const getUserDeleteUrl = (userId, ignoreConflicts) =>
  `users/${userId}${ignoreConflicts ? "?ignoreConflicts=true" : ""}`;
export const getUserSendResetPasswordMailUrl = () => "Users/RecoveryPassword";
export const getUserResetPasswordUrl = () => "Users/ResetPassword";
export const getUserChangePasswordUrl = () => "Users/ChangePassword";
export const getUserVerifyMailUrl = () => "Users/VerifyMail";
export const getUserSetPermissionsUrl = userId => `Users/${userId}/NodeCross/Permissions`;

/* geometry */
export const getGeometryUrl = (nodeId, format, detailLevel, timeDimValue, territoryDimCodelist, generalizationLevel) =>
  `geometry/${nodeId}?format=${format}` +
  (detailLevel !== null && detailLevel !== undefined ? `&geoLevel=${detailLevel}` : "") +
  (timeDimValue !== null && timeDimValue !== undefined ? `&year=${timeDimValue}` : "") +
  (territoryDimCodelist !== null && territoryDimCodelist !== undefined
    ? `&codelistId=${encodeURIComponent(territoryDimCodelist)}`
    : "") +
  (generalizationLevel !== null && generalizationLevel !== undefined
    ? `&generalizationLevel=${encodeURIComponent(generalizationLevel)}`
    : "");

/* permissions */
export const getNodePermissionsConfigGetUrl = nodeId => `Users/Permissions/Nodes/${nodeId}`;
export const getNodePermissionsConfigPutUrl = nodeId => `Users/Permissions/Nodes/${nodeId}`;

/* dashboards */
export const getDashboardUrl = (id, fetchFullInfo = false) =>
  `Dashboards/${id}` + (fetchFullInfo ? "?enrichWith=FullWithAllPartialOptimizedInfo" : "");
export const getUserDashboardsUrl = () => "Dashboards?permissions=Edit";
export const getNodeDashboardsUrl = nodeId => `Dashboards/Node/${nodeId}`;
export const getHubDashboardsUrl = () => `Dashboards/Hub`;
export const getDashboardCreateUrl = () => `Dashboards/`;
export const getDashboardUpdateUrl = id => `Dashboards/${id}`;
export const getDashboardDeleteUrl = id => `Dashboards/${id}`;
export const getDashboardShareManageUrl = () => "Dashboards/Share/Manage";

// TODO: remove
export const getAddHubDashboardUrl = dashboardId => `Dashboards/${dashboardId}/Hub`;
export const getRemoveHubDashboardUrl = dashboardId => `Dashboards/${dashboardId}/Hub`;
export const getOrderHubDashboardsUrl = () => "Dashboards/Order/Hub";
export const getAddNodeDashboardUrl = (nodeId, dashboardId) => `Dashboards/${dashboardId}/Nodes/${nodeId}`;
export const getRemoveNodeDashboardUrl = (nodeId, dashboardId) => `Dashboards/${dashboardId}/Nodes/${nodeId}`;
export const getOrderNodeDashboardsUrl = nodeId => `Dashboards/Order/Nodes/${nodeId}`;

/* dashboard filters */
export const getFilterUrl = id => `Filters/${id}`;
export const getFiltersUrl = (includeValues = false) => `Filters?includeValues=${includeValues}`;
export const getFilterDeleteUrl = id => `Filters/${id}`;
export const getFilterInfoUrl = () => "Filters/info";
export const getFilterImportUrl = () => "Filters/import";

/* custom pages */
export const getCustomPageUrl = (id, fetchFullInfo = false) =>
  `CustomPages/${id}` + (fetchFullInfo ? "?enrichWith=FullWithAllPartialOptimizedInfo" : "");
export const getUserCustomPagesUrl = () => "CustomPages";
export const getNodeCustomPagesUrl = nodeId => `CustomPages/Node/${nodeId}`;
export const getHubCustomPagesUrl = () => `CustomPages/Hub`;
export const getCustomPageCreateUrl = () => `CustomPages/`;
export const getCustomPageUpdateUrl = id => `CustomPages/${id}`;
export const getCustomPageDeleteUrl = id => `CustomPages/${id}`;

/* widget */
export const getWidgetUrl = id => `Widgets/${id}?enrichWith=FullWithAllPartialOptimizedInfo`;
export const getUserWidgetsUrl = type => `Widgets/type/${type}?showOwner=true`;
export const getWidgetCreateUrl = () => `Widgets/`;
export const getWidgetUpdateUrl = id => `Widgets/${id}`;
export const getWidgetDeleteUrl = id => `Widgets/${id}`;
export const getWidgetDatasetUrl = (widgetId, itemId, lastNObservations) =>
  `Widgets/${widgetId}/Items/${itemId}/Data/` + (lastNObservations ? `?lastNObservations=${lastNObservations}` : "");
export const getWidgetDatasetCustomDownloadUrl = (widgetId, itemId, format, zipped, lastNObservations) =>
  `Widgets/${widgetId}/Items/${itemId}/Export/${format}/${zipped === true ? "true" : "false"}` +
  (lastNObservations ? `?lastNObservations=${lastNObservations}` : "");
export const getWidgetDatasetDownloadUrl = (widgetId, itemId, format, zipped, lastNObservations) =>
  `Widgets/${widgetId}/Items/${itemId}/${zipped === true ? "downloadZip" : "download"}/${format}` +
  (lastNObservations ? `?lastNObservations=${lastNObservations}` : "");

/* optimized data retriever */
export const getOptimizedDataDatasetPageSizeUrl = nodeId => `nodes/${nodeId}/PageDimension`;
export const getDimensionValuesUrl = (nodeId, datasetId, dimensionId) =>
  `nodes/${nodeId}/datasets/${datasetId}/DimensionValues/${dimensionId}`;
export const getNotEmptyCombinationUrl = (nodeId, datasetId, onlyCount = false, withAttributes = false) =>
  `nodes/${nodeId}/datasets/${datasetId}/NotEmptyCombinations` +
  (onlyCount ? "/count" : "") +
  `?withAttributes=${withAttributes}`;
export const getOptimizedDataOffsetUrl = (nodeId, datasetId, offset) =>
  `nodes/${nodeId}/datasets/${datasetId}/Data/Offset/${offset}`;
export const getOptimizedMapDataUrl = (nodeId, datasetId) => `nodes/${nodeId}/datasets/${datasetId}/TerritoryData`;
export const getSynthesisAndVariabilityMeasuresUrl = (nodeId, datasetId) =>
  `nodes/${nodeId}/datasets/${datasetId}/SynthesisAndVariabilityMeasure`;

export const getTerritorialClassificationsUrl = detailLevel => `parentLayers/${detailLevel}`;
export const getTerritorialClassificationsValuesUrl = nodeId => `nodes/${nodeId}/parents`;

/* resource export */
export const getResourceDownloadUrl = (nodeId, packageId, resourceId) =>
  `nodes/${nodeId}/Package/${packageId}/Resource/${resourceId}/Download`;

/* package manager - etl */
export const getStructuredDataSuggestionsUrl = (nodeId, resourceId, autodetect) =>
  `Nodes/${nodeId}/DataStore/StructuredDataSuggestions/${resourceId}/${autodetect}`;

export const getStructuredDataDefinitionUrl = (nodeId, resourceId, autodetect) =>
  `Nodes/${nodeId}/DataStore/StructuredDataDefinition/${resourceId}/${autodetect}`;

export const getImportDataUrl = (nodeId, packageId, resourceId, forceImport) =>
  `Nodes/${nodeId}/DataStore/ImportData/${packageId}/${resourceId}${forceImport ? "/true" : ""}`;

export const getEtlResourceUrl = (nodeId, resource) => `Nodes/${nodeId}/DataStore/Metadatasets/Dataflow/${resource}`;

/* package manager - schema */
export const getSchemaUrl = (nodeId, setIdentifier, resolveRefs = true) =>
  `Nodes/${nodeId}/DataStore/Metadatasets/Schema/${setIdentifier}?elements=${resolveRefs}`;

export const getPackageSchemaUrl = (nodeId, resolveRefs) => getSchemaUrl(nodeId, "Package", resolveRefs);
export const getResourceSchemaUrl = (nodeId, resolveRefs) => getSchemaUrl(nodeId, "Resource", resolveRefs);
export const getAgentSchemaUrl = (nodeId, resolveRefs) => getSchemaUrl(nodeId, "Agent", resolveRefs);
export const getThemeSchemaUrl = (nodeId, resolveRefs) => getSchemaUrl(nodeId, "Theme", resolveRefs);
export const getPackageLicenseSchemaUrl = (nodeId, resolveRefs) => getSchemaUrl(nodeId, "PackageLicense", resolveRefs);
export const getResourceLicenseSchemaUrl = (nodeId, resolveRefs) =>
  getSchemaUrl(nodeId, "ResourceLicense", resolveRefs);

/* package manager - metadataset */
export const getMetadatasetsUrl = (nodeId, setIdentifier, metadatasetIdentifier, queryParams = {}) => {
  const url = `Nodes/${nodeId}/DataStore/Metadatasets/${setIdentifier}${metadatasetIdentifier ? "/" + metadatasetIdentifier : ""}`;

  const params = new URLSearchParams();
  if (queryParams.useRelativePaths) {
    params.append("include", "__FileMarkers");
  }
  if (queryParams.useStub) {
    params.append("include", "__Stub");
  }

  const queryString = params.toString();

  return queryString ? `${url}?${queryString}` : url;
};

/* package manager - metadataset DataPortal */
export const getPackageUrl = (nodeId, packageId, queryParams = {}) =>
  getMetadatasetsUrl(nodeId, "Package", packageId, queryParams);
export const getResourceUrl = (nodeId, resourceId, queryParams = {}) =>
  getMetadatasetsUrl(nodeId, "Resource", resourceId, queryParams);
export const getThemeUrl = (nodeId, themeId, queryParams = {}) =>
  getMetadatasetsUrl(nodeId, "Theme", themeId, queryParams);
export const getAgentUrl = (nodeId, agentId, queryParams = {}) =>
  getMetadatasetsUrl(nodeId, "Agent", agentId, queryParams);
export const getPackageLicenseUrl = (nodeId, packageLicenseId, queryParams = {}) =>
  getMetadatasetsUrl(nodeId, "PackageLicense", packageLicenseId, queryParams);
export const getResourceLicenseUrl = (nodeId, resourceLicenseId, queryParams = {}) =>
  getMetadatasetsUrl(nodeId, "ResourceLicense", resourceLicenseId, queryParams);

export const getCodelistUrl = nodeId => getMetadatasetsUrl(nodeId, "Codelist");

/* package manager - metadataset Ckan */
export const getCkanPackageUrl = nodeId => getMetadatasetsUrl(nodeId, "CkanPackage");
export const getCkanResourceUrl = nodeId => getMetadatasetsUrl(nodeId, "CkanResource");
export const getCkanGroupUrl = nodeId => getMetadatasetsUrl(nodeId, "CkanGroup");
export const getCkanOrganizationUrl = nodeId => getMetadatasetsUrl(nodeId, "CkanOrganization");

export const getPreloadFileUrl = nodeId => `Nodes/${nodeId}/DataStore/Preload`;
export const getPackagePermissionsUrl = nodeId => `Users/Permissions/Nodes/${nodeId}/Entities/Blacklist`;

/* superset */
export const getSyncSupersetUrl = nodeId => getMetadatasetsUrl(nodeId, "SupersetSync");

export const getSupersetDependenciesUrl = (nodeId, resourceId) =>
  getMetadatasetsUrl(nodeId, "SupersetDependencies", resourceId);

/* ai */
export const getAIAssistantChatbotUrl = (nodeId, packageId) =>
  `ai/nodes/${nodeId}/catalog/search` + (packageId ? `?packageIdentifier=${packageId}` : "");
export const getAIAssistantMetadataUrl = (nodeId, packageId) => `ai/nodes/${nodeId}/packages/${packageId}/metadata`;
export const getAIAssistantAnalysisUrl = (nodeId, packageId, resourceId) =>
  `ai/nodes/${nodeId}/packages/${packageId}/resources/${resourceId}/analyze`;
export const getAIAssistantCatalogRefreshUrl = nodeId => `manage/nodes/${nodeId}/catalog/refresh`;
export const getAIAssistantSettingsAuthUrl = () => "config/auth/token";
export const getAIAssistantSettingsChangePwdUrl = () => "config/auth/modify";
export const getAIAssistantFeaturesUrl = nodeId => `config/nodes/${nodeId}/features`;
export const getAIAssistantEnginesUrl = nodeId => `config/nodes/${nodeId}/engines`;
export const getAIAssistantEngineUrl = (nodeId, engineId) => `config/nodes/${nodeId}/engines/${engineId}`;
export const getAIAssistantEnabledFeaturesUrl = nodeId => `config/nodes/${nodeId}/features/enabled`;
